import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

// Disable service worker caching in this build to avoid stale assets during frequent deploys
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  }).catch(() => {});
}

// Check for required environment variables
const requiredEnvVars = ['VITE_GOOGLE_CLIENT_ID'];
const missingEnvVars = requiredEnvVars.filter(
  (varName) => !(import.meta as any).env?.[varName]
);

if (missingEnvVars.length > 0) {
  console.warn(
    `Missing environment variables: ${missingEnvVars.join(', ')}. Some features may not work properly.`
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
